import SectionHead from './SectionHead'

const ROWS = [
  {
    old: 'Generic AI training videos',
    new: 'A workshop on the work you already do',
  },
  {
    old: 'Everyone uses AI differently',
    new: 'One process the whole team agreed on',
  },
  {
    old: 'Prompts with nothing written down behind them',
    new: 'Documentation first, then a prompt that holds up',
  },
  {
    old: 'Nobody knows where AI falls over',
    new: 'Agents that say plainly what they cannot do',
  },
]

export default function OldVsNewSection() {
  return (
    <section className="bg-surface py-14 md:py-16 border-y-2 border-navy">
      <div className="mktg-container">
        <SectionHead mark="SECT. 01" title="Why it works" />

        <div className="max-w-3xl">
          <div className="grid grid-cols-[1fr_1fr] gap-4 md:gap-8 pb-2 border-b-2 border-navy">
            <span className="mono-label text-navy/70">The usual</span>
            <span className="mono-label text-teal">Day One</span>
          </div>
          {ROWS.map((row) => (
            <div
              key={row.old}
              className="grid grid-cols-[1fr_1fr] gap-4 md:gap-8 py-4 border-b border-navy/20"
            >
              <p className="text-sm md:text-base text-navy/70 line-through decoration-brick decoration-1">
                {row.old}
              </p>
              <p className="flex items-start gap-2.5 text-sm md:text-base text-navy font-medium">
                <span className="waypoint mt-1.5" aria-hidden="true" />
                {row.new}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
